<template>
    <div class="class-reminder-page">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="head">
                <i class="back"
                   @click="back()"></i>
                <p class="title">应用提醒</p>
                <p class="send"
                   @click="send()">发通知</p>
            </div>
            <template v-if="list.length">
                <div class="reminder-list">
                    <div class="reminder-item"
                         @click="toDetail(item)"
                         v-for="(item,index) in list"
                         :key="index">
                        <div class="class-name">
                            <strong>{{item.title}}</strong>
                            <span v-if="item.is_schedule==1">{{item.schedule_time}}</span>
                            <span v-else>{{item.add_time}}</span>
                        </div>
                        <div class="reminder-text">
                            <p v-html="item.content"></p>
                        </div>
                        <div class="tips">
                            <p>{{item.type}}</p>
                            <span>{{item.is_schedule==0?'已发送':(item.is_schedule==1&&item.status==1)?'未发送':(item.is_schedule==1&&item.status==3)?'已撤销':(item.is_schedule==1&&item.status==4)?'已发送':''}}</span>
                        </div>
                    </div>
                </div>
            </template>
            <no-resouse v-else></no-resouse>
        </template>
    </div>
</template>

<script>
import noResouse from 'SRC/components/noResouse.vue';
import loadings from "COMPONENTS/base/loadingS.vue";
export default {
    components: {
        noResouse, loadings
    },
    data () {
        return {
            loading: true,
            list: [],
            page_no: 1,
        }
    },
    created () {
        localStorage.removeItem('stuList')
        localStorage.removeItem('reminderUnits')
        localStorage.removeItem('is_schedule')
        localStorage.removeItem('defaultTime')
        localStorage.removeItem('defaultTimeStr')
        localStorage.removeItem('radio_type')
        this.getReminderList()
        window.addEventListener("scroll", this.scrollBottom);
    },
    methods: {
        getReminderList () {
            let url = API_URL_JXGT_API + '/message/list'
            let params = {
                page: this.page_no,
                user_type: 3,
                flag: 1,
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response == 'ok') {
                    if (!res.data.data.length) {
                        layer.tips('已加载全部内容')
                        window.removeEventListener("scroll", this.scrollBottom);
                    } else {
                        this.page_no++;
                    }
                    this.list = this.list.concat(res.data.data);
                }
                this.loading = false
            })
        },
        //滚动监听事件
        scrollBottom () {
            //加载更多
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight && scrollTop > 100) {
                //写后台加载数据的函数
                this.getReminderList();
            }
        },
        //查看通知详情
        toDetail (item) {
            this.$router.push(`/reminder/detail/${item.unit_id}/${item.id}`)
        },
        //发通知
        send () {
            this.$router.push('/reminder/send?from=1')
        }
    },
    destroyed () {
        window.removeEventListener("scroll", this.scrollBottom);
    }
}
</script>

<style lang="scss" scoped>
.class-reminder-page {
    padding-top: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(../img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .send {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
.reminder-list {
    padding: 0 24px / $ppr;
    .reminder-item {
        background: #fff;
        border-radius: 15px / $ppr;
        padding: 24px / $ppr;
        margin: 24px / $ppr 0;
        .class-name {
            display: flex;
            justify-content: space-between;
            align-items: center;
            strong {
                font-size: 36px / $ppr;
                color: #333;
                font-weight: bold;
            }
            span {
                font-size: 24px / $ppr;
                color: #999;
            }
        }
        .reminder-text {
            color: #555;
            font-size: 30px / $ppr;
            padding: 24px / $ppr 0;
            border-bottom: 1px solid #e8e8e8;
            line-height: 1.7;
            white-space: pre-wrap;
        }
        .tips {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 24px / $ppr;
            color: #999;
            font-size: 24px / $ppr;
        }
    }
}
</style>